module.exports = __webpack_public_path__ + "img/zz1.ae3b1f54.jpg";